import _ from 'underscore'

import { translateTicket } from '../../utils/serialTickets'

export function addTicketToBooking(draftBooking, ticket) {
  prepareBookingForNewTicket(draftBooking, ticket)
  const [serviceIndex, ticketIndex] = getIndexesOfTicket(draftBooking, ticket)
  draftBooking.services[serviceIndex].tickets[ticketIndex].quantity += 1
}

export function removeTicketFromBooking(draftBooking, ticket) {
  const [serviceIndex, ticketIndex] = getIndexesOfTicket(draftBooking, ticket)
  draftBooking.services[serviceIndex].tickets[ticketIndex].quantity -= 1
  cleanUpBookingAfterRemovingTicket(draftBooking, [serviceIndex, ticketIndex])
}

export function mapReservationResponseToBooking({ serialTickets, totalPrice }) {
  const packageTypeDict = _.groupBy(serialTickets, getTicketPackageType)
  const services = Object.entries(packageTypeDict).map(([packageType, tickets]) => ({
    packageDirection: 'forward',
    packageType,
    tickets: tickets.map(translateTicket).map(mapReservationTicketToDigiDataTicket)
  }))

  return {
    totalPoints: 0,
    totalMoney: totalPrice,
    services
  }
}

function prepareBookingForNewTicket(draftBooking, ticket) {
  addServiceIfNotExist(draftBooking, ticket)
  addTicketIfNotExist(draftBooking, ticket)
}

function cleanUpBookingAfterRemovingTicket(draftBooking, ticketIndexes) {
  removeTicketIfHasNoQuantity(draftBooking, ticketIndexes)
  removeServiceIfHasNoTickets(draftBooking, ticketIndexes)
}

function getIndexesOfTicket(draftBooking, ticket) {
  const serviceIndex = draftBooking.services.findIndex(service => service.packageType === getTicketPackageType(ticket))
  const ticketIndex = draftBooking.services[serviceIndex].tickets.findIndex(
    ({ code }) => code === getTicketCode(ticket)
  )

  return [serviceIndex, ticketIndex]
}

function addServiceIfNotExist(draftBooking, ticket) {
  const packageType = getTicketPackageType(ticket)

  if (!draftBooking.services.some(service => service.packageType === packageType)) {
    draftBooking.services.push({ tickets: [], packageType, packageDirection: 'forward' })
  }
}

function addTicketIfNotExist(draftBooking, ticket) {
  const ticketCode = getTicketCode(ticket)
  const serviceIndex = draftBooking.services.findIndex(
    ({ packageType }) => packageType === getTicketPackageType(ticket)
  )

  if (!draftBooking.services[serviceIndex].tickets.some(ticket => ticket.code === ticketCode)) {
    draftBooking.services[serviceIndex].tickets.push({
      code: ticketCode,
      price: ticket.price,
      title: getTicketTitle(ticket),
      points: 0,
      quantity: 0
    })
  }
}

function removeTicketIfHasNoQuantity(draftBooking, [serviceIndex, ticketIndex]) {
  if (draftBooking.services[serviceIndex].tickets[ticketIndex].quantity === 0) {
    draftBooking.services[serviceIndex].tickets = draftBooking.services[serviceIndex].tickets.filter(
      (_, index) => index !== ticketIndex
    )
  }
}

function removeServiceIfHasNoTickets(draftBooking, [serviceIndex]) {
  if (draftBooking.services[serviceIndex].tickets.length === 0) {
    draftBooking.services = draftBooking.services.filter((service, index) => index !== serviceIndex)
  }
}

const getTicketPackageType = ticket => `${ticket.from}-${ticket.to}`.toLowerCase()
const getTicketCode = ticket => ticket.code.toLowerCase()
const getTicketTitle = ticket => ticket.title.toLowerCase()

const mapReservationTicketToDigiDataTicket = ticket => ({
  code: getTicketCode(ticket),
  quantity: ticket.count,
  price: ticket.unitPrice,
  points: 0,
  title: getTicketTitle(ticket)
})
